var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer no-print"},[_c('span',[_c('a',{attrs:{"href":"https://app.thegpservice.co.uk"}},[_vm._v("The GP Service")]),_vm._v(" © 2018")])])
}]

export { render, staticRenderFns }